import React from 'react'
import IconButton from '../common/components/IconButton'
import { inlineTooltipStyle } from '../common/components/tooltipStyles'
import CopyButtonBase from '../common/components/CopyButtonBase.jsx'


export default function RowOfMessageInteractionIcons(
  {
    row,
    transactionKey,
    isExpanded,
    onToggleExpand,

    showOnClick,
    showOnDownload,
    showOnCopy,
    getPreview,

    handleCopyClick,
    handlePreviewEnter,
    handlePreviewLeave,

    isRowJustCopied,
    isPreviewing,
    previewText
  }
) {
  return (
    <td
      style={{
        position: 'relative',
        whiteSpace: 'nowrap',
        minWidth: '153px',
        maxWidth: '153px',
      }}
    >
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
        <IconButton
          iconName={isExpanded ? 'caret up' : 'caret down'}
          ariaLabel={isExpanded ? 'Close inline' : 'Open inline'}
          tooltip={isExpanded ? 'Close inline' : 'Open inline'}
          buttonProps={row.getToggleRowExpandedProps({
            onClick: () => onToggleExpand(transactionKey),
          })}
        />

        {showOnClick && (
          <IconButton
            iconName="external"
            ariaLabel="Open in popup"
            tooltip="Open in popup"
            preventDefault
            stopPropagation
            onClick={() => showOnClick(row)}
          />
        )}

        {showOnDownload && (
          <IconButton
            iconName="download"
            ariaLabel="Download"
            tooltip="Download"
            preventDefault
            stopPropagation
            onClick={() => showOnDownload(row)}
          />
        )}
        {showOnCopy && (
          <CopyButtonBase
            onClick={(e) => handleCopyClick(e, row)}
            justCopied={isRowJustCopied}
            ariaLabel="Copy"
          />
        )}
        {getPreview && (
          <span style={{ position: 'relative', display: 'inline-block' }}>
            <IconButton
              iconName="eye"
              ariaLabel="Preview details"
              tooltip={null}
              onMouseEnter={(e) => handlePreviewEnter(e, row)}
              onMouseLeave={(e) => handlePreviewLeave(e, row)}
              onFocus={(e) => handlePreviewEnter(e, row)}
              onBlur={(e) => handlePreviewLeave(e, row)}
            />

            {isPreviewing && previewText && (
              <span style={inlineTooltipStyle}>{previewText}</span>
            )}
          </span>
        )}
      </span>
    </td>
  )
}
